import { actionTypes } from "../utils";

export const types = {
  ...actionTypes('SET_ORGANIZATIONS'),
  ...actionTypes('CREATE_ORGANIZATION'),
  ...actionTypes('DELETE_ORGANIZATION'),
  ...actionTypes('RESET_ORGANIZATIONS'),
  ...actionTypes('SET_USERS_DATA'),
  ...actionTypes('UPDATE_ORG_INT_CATEGORIES'),
};